import { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../Config/config';
import { useTenant } from '../Context/TenantContext';
import { parseLogoUrl, getFallbackLogo } from '../utils/logoUtils';

/**
 * useCollegeLogo
 *
 * Custom hook to resolve the college logo consistently across the app.
 * It prioritizes the latest logo from the database (via college API)
 * and falls back to the Tenant context, then a hardcoded default.
 */
export const useCollegeLogo = () => {
  const { getLogoUrl, tenant } = useTenant();
  const [apiLogo, setApiLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLogo = async () => {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const username = user?.username || user?.userId;

      if (!username) return;

      setLoading(true);
      try {
        const res = await axios.get(`${API_BASE_URL}/colleges/username/${username}`);
        if (res.data?.logo) {
          const resolved = parseLogoUrl(res.data.logo);
          if (resolved) setApiLogo(resolved);
        }
      } catch (err) {
        console.error("Error fetching college logo:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchLogo();
  }, []);

  // Priority: API > Tenant Context > Default
  const resolvedLogo = apiLogo || parseLogoUrl(tenant?.logoUrl) || getLogoUrl() || getFallbackLogo();

  return { logo: resolvedLogo, loading };
};